import createLogger from '@/utils/logger'

// LocalStorage key for coupon
const PROMO_CODE_STORAGE_KEY = 'greatly_promo_code'

const logger = createLogger('components/stripeCoupon')

// Function to save coupon to localStorage
export const savePromoCodeToStorage = (promoCode: string | null) => {
  try {
    if (promoCode) {
      localStorage.setItem(PROMO_CODE_STORAGE_KEY, promoCode)
      logger.log('Promo code saved to localStorage:', promoCode)
    } else {
      localStorage.removeItem(PROMO_CODE_STORAGE_KEY)
      logger.log('Promo code removed from localStorage')
    }
  } catch (error) {
    logger.error('Error saving promo code to localStorage:', error)
  }
}

// Function to load coupon from localStorage
export const loadPromoCodeFromStorage = (): string | null => {
  try {
    const stored = localStorage.getItem(PROMO_CODE_STORAGE_KEY)
    if (stored) {
      logger.log('Promo code loaded from localStorage:', stored)
      return stored
    }
  } catch (error) {
    logger.error('Error loading promo code from localStorage:', error)
  }
  return null
}
